import { PaymentMethod } from '../../interfaces';
import { PAYMENT_METHOD_ID } from '../payment-method-id';

export const DIRECT_PAY: PaymentMethod = {
    id: PAYMENT_METHOD_ID.DirectPay,
    name: 'directpay',
    displayName: 'Sofort'
};
